import type { ThunkBase } from "~/rocketchat/redux/types";

import type { UnreadCount } from "@daangn/idl/rocketchat/api/model";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { createThunkName } from "~/rocketchat/redux/createThunkNamespace";
import { updateChannelAggregationData } from "../channelSlice";

type MarkAsReadMessageThunkPayload = {
  unreadCount: UnreadCount | undefined;
};

export const markAsReadMessageThunk = createAsyncThunk<
  void,
  MarkAsReadMessageThunkPayload,
  ThunkBase
>(
  createThunkName("markAsReadMessageThunk"),
  async ({ unreadCount }, { dispatch, getState }) => {
    const currentUnreadCount = getState().channel.unreadCount;

    dispatch(
      updateChannelAggregationData({
        unreadCount: unreadCount ?? currentUnreadCount,
      }),
    );
  },
);
